<template>
  <div
    class="w-[100vw] h-[100vh] fixed top-0 left-0 z-[9999] flex justify-center items-center bg-[#0000005a]"
  >
    <div
      class="w-[40vw] text-white gap-4 p-4 bg-[#5D5D98] rounded-[10px] flex flex-col glass-app popup-content"
    >
      <div class="w-full flex gap-2 justify-between items-center">
        <h3 class="text-[#ff9b05]"></h3>
        <div class="flex gap-2 items-center">
          <AppButton
            class="text-white"
            v-bind:visibility="true"
            left_icon="fa-regular fa-circle-xmark fa-xl"
            emitType="close"
            @close="close"
            :width="23"
            :height="23"
          />
        </div>
      </div>

      <div class="w-full">
        <AppTablePagination
          :visibility="true"
          :show="true"
          :table_title="title"
          @row-clicked="selectRowData"
          :static_data="table_data"
          @close="null"
          class="h-full"
          @row-dClicked="ConfirmDialog"
          :multiSelect="{
            show: this.multiSelect,
            isActive: this.isActive,
            buttons: {
              add: {
                show: false,
                enabled: true,
                text: '',
                color: '#ff9b05',
                icon: 'fa-solid fa-pen-to-square',
                emit: 'send-selected-rows',
              },
              delete: {
                show: false,
                enabled: false,
                text: '',
                color: 'red',
                icon: 'fa-solid fa-trash-alt',
                emit: 'remove-selected-rows',
              },
            },
          }"
          @multiRow-clicked="selectMultiRowData"
        />
      </div>

      <div class="flex gap-1 ml-auto">
        <section class="right flex gap-2">
          <button
            class="p-1 text-[.7em] rounded-md bg-[red]"
            @click="CancelDialog"
          >
            Cancelar
          </button>
          <button
            class="p-1 text-[.7em] rounded-md bg-[#006698]"
            @click="ConfirmDialog"
          >
            Confirmar
          </button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import AppTable from "@/components/tables/table.vue";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import AppButton from "@/components/updated/button.vue";
import { toast } from "vue3-toastify";

export default {
  components: {
    AppTable,
    AppTablePagination,
    AppButton,
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
      default: "",
    },
    multiSelect: {
      type: Boolean,
      default: true,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      table_data: this.data,
      currentEntity: 0,
      selectedRow: { index: 0, data: {} },
      selectedRow2: [],
      sendMultiData: false,
      table_data: [],
    };
  },
  methods: {
    close() {
      this.showFilter = false;
      this.showClienteFilter = false;
      this.$emit("close");
    },

    selectRowData(row) {
      this.sendMultiData = false;
      this.selectedRow = { index: this.currentEntity, data: row };
      this.selectedRow2[this.currentEntity] = row;

      // console.table(this.selectedRow2);
    },
    selectMultiRowData(rows) {
      console.log("Rows: ", rows);
      this.sendMultiData = true;

      this.selectedRow2 = rows;
      // console.table(this.selectedRow2);
    },

    ConfirmDialog() {
      //J...06_02_2025
      if (
        !this.selectedRow2 ||
        (Array.isArray(this.selectedRow2) && this.selectedRow2.length === 0)
      ) {
        toast.info("Por favor, selecione uma linha antes de confirmar!", {
          position: "top-right",
          timeout: 3000,
        });
        return;
      }

      if (this.sendMultiData) {
        console.log("Multi data: ", this.selectedRow2);
        if (this.title) {
          this.$emit("returnData", { [this.title]: this.selectedRow2 });
        } else this.$emit("returnData", { entity: this.selectedRow2 });
      } else if (this.title) {
        this.$emit("returnData", { [this.title]: this.selectedRow2[0] });
      } else this.$emit("returnData", { entity: this.selectedRow2[0] });

      this.$emit("close");
    },
    CancelDialog() {
      // if(this.selectedRow2.length > 0){

      // }else{
      this.selectedRow2 = [];
      this.$emit("close");

      // }
    },
  },

  watch: {
    data: {
      handler: function (val) {
        this.table_data = val;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.footer {
  display: flex;
  justify-content: space-between;
  gap: 1em;
}
</style>
